import React, { useState, useEffect } from "react";
import StepperStep from "./stepper-step"
import Call from "../../assets/img/Call.svg"
import Lock from "../../assets/img/Lock.svg"
import InactiveLock from "../../assets/img/InactiveLock.svg"
import heart from "../../assets/img/heart.svg"
import InactiveHeart from "../../assets/img/InactiveHeart.svg"
import Translation from "../../services/translation.service"
import Storage from "../../services/storage.service"

const prefix = "stm_advertisement_stepper_"
let subscriptions = []
const AdvertismentStepper = () => {
    const [info, setInfo] = useState({});
    useEffect(() => {
        subscriptions.push(
            Storage.get_obsrv("act_step_detail").subscribe(data => {
                if (data) {
                    setInfo(data)
                }
            })
        );

        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        };
    }, []);

    return (<div className="protection_channel_progress_container">
    <StepperStep
    title={Translation[prefix + "step1_title"] || "Your number"}
    desc={Translation[prefix + "step1_desc"] || "Start by entering your number"}
    step="1"
            status={info?.step1?.status}
    icon={Call}
    nonActive={Call}
    />
    <div className="divider"></div>
    <StepperStep
    title={ Translation[prefix + "step2_title"] || "OTP Validation"}
    desc={Translation[prefix + "step2_desc"] || "Validated"}
    step="2"
            status={info?.step2?.status}
    icon={Lock}
    nonActive={InactiveLock}
    />
    <div className="divider"></div>
    <StepperStep
    title={Translation[prefix + "step3_title"] || "Advertisment"}
    desc={Translation[prefix + "step3_desc"] || "Opt in or out"}
    step="3"
            status={info?.step3?.status}

    icon={heart}
    nonActive={InactiveHeart}
    />
    </div>)
}
 
export default AdvertismentStepper